import { render, staticRenderFns } from "./tprConfig.vue?vue&type=template&id=b2529e7a&"
import script from "./tprConfig.vue?vue&type=script&lang=js&"
export * from "./tprConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports